import { BrowserRouter, Routes, Route } from 'react-router-dom';
// components
import Courses from './pages/Courses/Courses';
import Home from './pages/Home/Home';
import ContactUs from './pages/ContactUs/ContactUs';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={<Home />}
        />
        <Route
          path='/courses'
          element={<Courses />}
        />
        <Route
          path='/contact-us'
          element={<ContactUs />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
